module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("‘Are you indeed certain you wish to wed me?’")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("‘It is the only way I can keep you safe,’ he said. ‘As my betrothed wife I put my seal on you. Any man who tries to take you from me will know they become my mortal enemy.’")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Rosamunde glanced away. Her heart was racing. She had agreed to wed him, and she sensed—felt—the passion in him. Raphael wanted her, but he had made it clear that he could never love her. He had obviously loved his wife greatly, but she was in her grave. He was only marrying Rosamunde to protect her. He considered it his duty to care for her, and she knew he would keep her safe—but she wanted more from her marriage than that.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f58dbd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/exprt.vue
// module id = 57
// module chunks = 0